export const getUsers = () => `/api/users`;
export const userLogin = () => `/api/login`;
export const userLogout = () => `/api/logged-out`;
export const getMenuItems = () => `/api/menu/items`;
export const sentContactFormPath = () => `/api/contact-form/sent`;
export const sentNewsletterFormPath = () => `/api/newsletter-form/sent`;

export const getCategories = () => `/api/site/categories/get`;
export const getProductsCategoriesType = (type) =>
  `/api/site/products/categories/type/get/${type}`;
export const getProducts = () => `/api/site/products/get`;
export const getProductsWithPagination = () => `/api/site/products/catalog/get`;
export const getSearchProducts = (dataValue) =>
  `/product/search?name=${dataValue?.text}&asc=${dataValue?.orderCatalog}`;
export const getPageNumberTotal = () =>
  `/api/site/catalog/pagination/number/get`;
export const getCatalogFilters = () => `/api/site/catalog/filters/get`;
export const getClientList = () => `/api/site/client/get`;
export const getSliderList = () => `/api/site/slider/get`;
export const getBannerList = () => `/api/site/banner/get`;

//api
export const getCatalogItems = () => `/api/catalog/get/items`;
export const getCategoriesItems = () => `/category`;
export const getCatalogFilterItems = (categoryId) =>
  `/product/filters/${categoryId}`;

export const getProductsMonthly = () => "/product/monthly-sale";
export const getProductsSale = () => "/product/sale";
export const getProductsRecommended = () => "/product/recommended";
export const getProductsHighlighted = () => "/product/highlighted";
export const getProductsTrending = () => "/product/trending";
export const getProductsBestSeller = () => "/product/best-seller";
export const getCatalogByFilters = (filters, categoryId, attr) => {
  if (!filters || filters.length === 0)
    return `/product/category/${categoryId}?size=${attr.size}&page=${attr.page}&asc=${attr.asc}`;

  const filtersArray = Array.isArray(filters)
    ? filters
    : filters.toString().split(",").filter(Boolean);

  const query = filtersArray
    .map((f) => `filters=${encodeURIComponent(f)}`)
    .join("&");

  return `product/category/${categoryId}?${query}&size=${attr.size}&page=${attr.page}&asc=${attr.asc}`;
};

export const getBlogAllListItems = (lang, id) =>
  `/api/blog/get/all/${lang}/${id}`;

export const getCartInfo = () => `/cart/info`;
export const addCartItem = () => `/cart/add`;
export const getCartSize = () => `/cart/size`;
export const getCartRemove = () => `/cart/remove`;
export const getCartFinish = () => `/cart/finish`;
export const getProductDetailItem = (id) => `/product/${id}`;
